var _defs, _use, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 342 234"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e2e8f0",
    strokeDasharray: 148,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 18,
    d: "M264.2 21.3A40 40 0 11293 89H9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0; 2960"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e2e8f0",
    strokeDasharray: 110,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 18,
    d: "M148.2 212.7A40 40 0 10177 145H9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0; 1540"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 342,
    height: 234,
    transform: "translate(85 139)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m249.6 180.7-5.8-3.4a14.3 14.3 0 000-6.6l5.8-3.4a4.1 4.1 0 001.4-5.5 4 4 0 00-5.5-1.5l-5.8 3.3a14.2 14.2 0 00-2.6-2 14.6 14.6 0 00-3-1.3v-6.7a4 4 0 10-8.1 0v6.7a14.2 14.2 0 00-5.7 3.3l-5.8-3.3a4 4 0 00-5.5 1.5 4.1 4.1 0 001.5 5.5l5.8 3.4a14.3 14.3 0 000 6.6l-5.8 3.4a4.1 4.1 0 00-1.5 5.5 4 4 0 005.5 1.5l5.8-3.3a14.2 14.2 0 002.6 2 13.8 13.8 0 003 1.3v6.7a4 4 0 108.1 0v-6.7a14.1 14.1 0 005.7-3.3l5.8 3.3a4 4 0 005.5-1.5 4.1 4.1 0 00-1.4-5.5Zm-22.6-1.4a6.2 6.2 0 01-2.2-8.4 6 6 0 015.2-3 6 6 0 013 .8 6.2 6.2 0 012.3 8.4 6 6 0 01-8.3 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x1",
    additive: "sum",
    attributeName: "transform",
    begin: ".5s; x1.end+1.33s",
    dur: "1.67s",
    type: "translate",
    values: "-30 0; 30 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: ".5s; x1.end+1.33s",
    dur: "1.67s",
    keyTimes: "0; .2; .8; 1",
    values: "0; 1; 1; 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m393.6 282.7-5.8-3.4a14.3 14.3 0 000-6.6l5.8-3.4a4.1 4.1 0 001.4-5.5 4 4 0 00-5.5-1.5l-5.8 3.3a14.2 14.2 0 00-2.6-2 14.6 14.6 0 00-3-1.3v-6.7a4 4 0 10-8.1 0v6.7a14.2 14.2 0 00-5.7 3.3l-5.8-3.3a4 4 0 00-5.5 1.5 4.1 4.1 0 001.5 5.5l5.8 3.4a14.3 14.3 0 000 6.6l-5.8 3.4a4.1 4.1 0 00-1.5 5.5 4 4 0 005.5 1.5l5.8-3.3a14.2 14.2 0 002.7 2 13.8 13.8 0 003 1.3v6.7a4 4 0 108 0v-6.7a14.1 14.1 0 005.7-3.3l5.8 3.3a4 4 0 005.5-1.5 4.1 4.1 0 00-1.4-5.5Zm-22.6-1.4a6.2 6.2 0 01-2.2-8.4 6 6 0 015.2-3 6 6 0 013 .8 6.2 6.2 0 012.3 8.4 6 6 0 01-8.3 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: "1s; x2.end+1.33s",
    dur: "1.67s",
    type: "translate",
    values: "-30 0; 30 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "1s; x2.end+1.33s",
    dur: "1.67s",
    keyTimes: "0; .2; .8; 1",
    values: "0; 1; 1; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "m163.6 340.7-5.8-3.4a14.3 14.3 0 000-6.6l5.8-3.4a4.1 4.1 0 001.4-5.5 4 4 0 00-5.5-1.5l-5.8 3.3a14.2 14.2 0 00-2.6-2 14.6 14.6 0 00-3-1.3v-6.7a4 4 0 10-8.1 0v6.7a14.2 14.2 0 00-5.7 3.3l-5.8-3.3a4 4 0 00-5.5 1.5 4.1 4.1 0 001.5 5.5l5.8 3.4a14.3 14.3 0 000 6.6l-5.8 3.4a4.1 4.1 0 00-1.5 5.5 4 4 0 005.5 1.5l5.8-3.3a14.2 14.2 0 002.6 2 13.8 13.8 0 003 1.3v6.7a4 4 0 108.1 0v-6.7a14.1 14.1 0 005.7-3.3l5.8 3.3a4 4 0 005.5-1.5 4.1 4.1 0 00-1.4-5.5Zm-22.6-1.4a6.2 6.2 0 01-2.2-8.4 6 6 0 015.2-3 6 6 0 013 .8 6.2 6.2 0 012.3 8.4 6 6 0 01-8.3 2.2Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x3",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; x3.end+1.33s",
    dur: "1.67s",
    type: "translate",
    values: "-30 0; 30 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s; x3.end+1.33s",
    dur: "1.67s",
    keyTimes: "0; .2; .8; 1",
    values: "0; 1; 1; 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSnow);
export default __webpack_public_path__ + "static/media/wind-snow.40015256a1c5aae3b2b6c70db57e5d0f.svg";
export { ForwardRef as ReactComponent };